/**
 * Reset window/document scroll when navigating to a new page.
 * Safe to call repeatedly; no-op in SSR.
 */
export function scrollToPageTop() {
  if (typeof window === "undefined") return;

  try {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  } catch {
    window.scrollTo(0, 0);
  }

  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const root = document.getElementById("root");
  if (root) root.scrollTop = 0;

  const main = document.querySelector("main");
  if (main) main.scrollTop = 0;
}
